import { render, staticRenderFns } from "./VerkaDashboardHeader.vue?vue&type=template&id=f016f756&scoped=true&"
import script from "./VerkaDashboardHeader.vue?vue&type=script&lang=ts&"
export * from "./VerkaDashboardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaDashboardHeader.vue?vue&type=style&index=0&id=f016f756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f016f756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
